import React from 'react';
import PropTypes from 'prop-types';
import ceil from 'lodash/ceil';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import range from 'lodash/range';
import { FlexRow, FlexCol } from '../sharedComponents/FlexGrid';
import Heading from '../sharedComponents/Heading';
import RecommendationsGridCard from './RecommendationsGridCard'
import Pagination from '../sharedComponents/Pagination';
import * as consts from './constants'

const propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    errorMsg: PropTypes.string,
    onCardSelect: PropTypes.func.isRequired,
    recommendations: PropTypes.object,
    type: PropTypes.string.isRequired,
    windowWidth: PropTypes.number
};

class RecommendationsGrid extends React.Component {

    state = {
        currentPage: 0
    };

    getNumberOfColumns = () => {
        return this.props.windowWidth > 768 ? 2 : 1;
    };

    getNumberOfPages = () => {
        const recommendationResults = get(this.props.recommendations, 'results', []);
        return  ceil(recommendationResults.length / (consts.NUMBER_OF_ROWS_IN_GRID * this.getNumberOfColumns()));
    };

    getFirstItemOnPage = () => {
        return (this.state.currentPage * consts.NUMBER_OF_ROWS_IN_GRID * this.getNumberOfColumns()) + 1;
    };

    getLastItemOnPage = () => {
        const recommendationResults = get(this.props.recommendations, 'results', []);
        let end = (this.getFirstItemOnPage() + (consts.NUMBER_OF_ROWS_IN_GRID * this.getNumberOfColumns())) - 1;
        end = end > recommendationResults.length ? recommendationResults.length : end;
        return end;
    };

    updatePage = (currentPage) => {
        this.setState({ currentPage });
    };

    renderColumn = (columnNum = 0) => {
        const recommendationResults = get(this.props.recommendations, 'results', []);
        if (isEmpty(recommendationResults)) {
            return '';
        }
        const rows = [];
        const start = (this.state.currentPage * consts.NUMBER_OF_ROWS_IN_GRID * this.getNumberOfColumns()) +
            (columnNum *  consts.NUMBER_OF_ROWS_IN_GRID);
        let end = start + consts.NUMBER_OF_ROWS_IN_GRID;
        end = end > recommendationResults.length ? recommendationResults.length : end;

        const highlightClass = '';
        const isFavorite = false;

        forEach(range(start, end), (index) => {
            const item = recommendationResults[index];
            if (item) {
                rows.push(
                    <RecommendationsGridCard
                        key={item.entity_id}
                        index={index}
                        startDate={this.props.startDate}
                        endDate={this.props.endDate}
                        dynamicClass={highlightClass}
                        isFavorite={isFavorite}
                        item={item}
                        layout="campground"
                        nth={index}
                        onCardSelect={this.props.onCardSelect}
                        val={highlightClass}
                        windowWidth={this.props.windowWidth} />
                );
            }
        });
        return rows;
    };

    renderRows = () => {
        const recommendationResults = get(this.props.recommendations, 'results', []);
        if (isEmpty(recommendationResults)) {
            return '';
        }
        const colsNum = this.getNumberOfColumns();
        const start = (this.state.currentPage * consts.NUMBER_OF_ROWS_IN_GRID * colsNum);
        let end = start + consts.NUMBER_OF_ROWS_IN_GRID * colsNum;
        end = end > recommendationResults.length ? recommendationResults.length : end;

        const highlightClass = '';
        const isFavorite = false;

        let cols = [];
        const rows = [];
        forEach(range(start, end), (index) => {
            const item = recommendationResults[index];
            if (item) {
                if (index%2 === 0) {
                    if (cols.length>0) {
                        rows.push(
                            <FlexRow key={`${index}_recommend_grid_row`}>
                                {cols}
                            </FlexRow>
                        );
                        cols = [];
                    }
                }
                cols.push(
                    <FlexCol key={item.entity_id} lg={6}>
                        <RecommendationsGridCard
                            index={index}
                            startDate={this.props.startDate}
                            endDate={this.props.endDate}
                            dynamicClass={highlightClass}
                            isFavorite={isFavorite}
                            item={item}
                            layout="campground"
                            nth={index}
                            onCardSelect={this.props.onCardSelect}
                            val={highlightClass}
                            windowWidth={this.props.windowWidth} />
                    </FlexCol>
                );
            }
        });
        if (cols.length>0) {
            rows.push(
                <FlexRow key={`last_recommend_grid_row`}>
                    {cols}
                </FlexRow>
            );
        }

        return rows;
    };

    renderBody = () => {
        if (this.props.windowWidth > 768) {
            return this.renderRows()
        }
        return (
            <div className='recommendation-grid'>
                {this.renderColumn(0)}
            </div>
        )
    };

    renderPagination = () => {
        const recommendationResults = get(this.props.recommendations, 'results', []);
        return (
            <FlexRow justifyContent="space-between" hasGutters={false} className="mt-2">
                <FlexCol xs={6} className="recommendation-grid--page-counter mb-2 mb-md-0">
                    {this.getFirstItemOnPage()} - {this.getLastItemOnPage()} of {recommendationResults.length} entries
                </FlexCol>
                <FlexCol sm="variable">
                    <Pagination
                        pages={this.getNumberOfPages()}
                        activePage={this.state.currentPage}
                        onChange={this.updatePage}
                        margin={2}
                        wings={1} />
                </FlexCol>
            </FlexRow>
        );
    };

    render() {
        return (
            <div className='recommendation-list--outer mt-6'>
                <Heading headingLevel={2} appearance="h6" className="mb-1">
                    Campgrounds Nearby
                </Heading>

                {this.renderBody()}
                {this.renderPagination()}
            </div>
        );
    }
}

RecommendationsGrid.propTypes = propTypes;

export default RecommendationsGrid;
